// extracted by mini-css-extract-plugin
export default {"dlRemoveButton":"src-js-components-RemoveButton---dlRemoveButton---s3Y2u"};